export const isDevelopment = process.env.VUE_APP_ENV_NAME === 'local';
export const isProduction = process.env.VUE_APP_ENV_NAME === 'PROD';
